/* GBI · homepage shared behaviour (H1). Spec: docs/specs/gbi-homepage-spec.md §3.5
   1. Click tracking for links inside [data-gbi-track] (dataLayer + Clarity via GBI.track)
   2. Same-page anchors ([data-gbi-anchor]): plain text when the target is missing, smooth scroll
   3. Collapsible lists on phones ([data-gbi-collapse] + [data-gbi-collapse-extra] + [data-gbi-expand])
   4. Hero video fades in on its first frame ([data-gbi-hero-frame] gets .is-started)
   Vanilla ES2019, one IIFE, run-once flag. Re-inits on shopify:section:load. */
(function () {
  'use strict';
  if (window.__gbiHome) return;
  window.__gbiHome = true;

  var doc = document;
  var reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function track(name, params) {
    if (!name) return;
    if (window.GBI && typeof window.GBI.track === 'function') window.GBI.track(name, params || {});
  }

  /* 1. data-gbi-track="event" on a link or on any ancestor of it (never a <details>: gbi-core
        tracks those). Params come from data-gbi-t-* on the same element: data-gbi-t-pos -> pos. */
  function paramsOf(el) {
    var out = {};
    Object.keys(el.dataset).forEach(function (k) {
      if (k.indexOf('gbiT') !== 0 || k.indexOf('gbiTrack') === 0 || k.length < 5) return;
      out[k.charAt(4).toLowerCase() + k.slice(5)] = el.dataset[k];
    });
    return out;
  }

  doc.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var host = a.closest('[data-gbi-track]');
    if (!host || host.tagName === 'DETAILS') return;
    track(host.getAttribute('data-gbi-track'), paramsOf(host));
  }, true);

  /* 2. Same-page anchors */
  function initAnchors(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('a[data-gbi-anchor]'), function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = null;
      try { target = doc.getElementById(decodeURIComponent(href.slice(1))); } catch (err) { target = null; }
      if (!target) {
        a.removeAttribute('href');
        a.classList.add('is-static');
        return;
      }
      if (a.__gbiAnchor) return;
      a.__gbiAnchor = true;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reducedMq.matches ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (err) { /* noop */ }
      });
    });
  }

  /* 3. Collapsible lists: JS adds .is-collapsed (CSS hides the extras below 750 px) and reveals
        the button. Without JS nothing is hidden. */
  function initCollapse(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-gbi-collapse]'), function (box) {
      if (box.__gbiCollapse) return;
      var btn = box.querySelector('[data-gbi-expand]');
      var extras = box.querySelectorAll('[data-gbi-collapse-extra]');
      if (!btn || !extras.length) return;
      box.__gbiCollapse = true;
      box.classList.add('is-collapsed');
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        box.classList.remove('is-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        btn.hidden = true;
        var first = extras[0].querySelector('a, button');
        if (first) {
          try { first.focus({ preventScroll: false }); } catch (err) { first.focus(); }
        }
        track(btn.getAttribute('data-gbi-expand-event') || 'home_list_expand', { list: box.getAttribute('data-gbi-collapse') || '' });
      });
    });
  }

  /* 4. Hero: media events do not bubble, so listen in the capture phase. */
  doc.addEventListener('playing', function (e) {
    var t = e.target;
    var frame = t && t.closest ? t.closest('[data-gbi-hero-frame]') : null;
    if (frame) frame.classList.add('is-started');
  }, true);

  function init(scope) {
    initAnchors(scope);
    initCollapse(scope);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  } else {
    init(doc);
  }
  doc.addEventListener('shopify:section:load', function () { init(doc); });
})();
